// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"320605b2","268":"51517be6","312":"2e29c778","551":"b0ffe9f2","650":"51c7b2cc"}[chunkId] + ".chunk.js";
};